/**
 * Quiltt Analytics Event Names
 * Central constants for all Quiltt bank connection analytics events
 */
const QUILTT_ANALYTICS_EVENTS = {
    // Connection Flow
    CONNECTOR_OPENED: 'Quiltt Connector Opened',
    CONNECTION_SUCCESS: 'Quiltt Connection Success',
    CONNECTION_ABORTED: 'Quiltt Connection Aborted',
    CONNECTION_FAILED: 'Quiltt Connection Failed',
    CONNECTION_DISCONNECTED: 'Quiltt Connection Disconnected',

    // Repair Flow
    REPAIR_CONNECTOR_OPENED: 'Quiltt Repair Connector Opened',
    REPAIR_SUCCESS: 'Quiltt Connection Repair Success',
    REPAIR_ABORTED: 'Quiltt Connection Repair Aborted',
    REPAIR_FAILED: 'Quiltt Connection Repair Failed',
} as const;

export default QUILTT_ANALYTICS_EVENTS;
